module.exports = "<div class=\"hierarchy-tree\">\n  <app-intelcia-tree [nodes]=\"nodes\" [onNodes]=\"onActivate()\" [search]=\"true\"></app-intelcia-tree>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/hierarchy-tree/hierarchy-tree.component.html
// module id = ./src/app/view/hierarchy-tree/hierarchy-tree.component.html
// module chunks = main